// extracted by mini-css-extract-plugin
export default {"welcome":"Welcome-module__welcome__JKoKY","title":"Welcome-module__title__ZIXJ4","stats":"Welcome-module__stats__E237S","stat":"Welcome-module__stat__9xbLV"};